export const API_URL_PREFIX = 
    'https://service.alwaysloved.xyz/'
    //'https://localhost:44383/'
    //'https://bor-service.azurewebsites.net/'

export const UPLOAD_SRC =
    //'https://test.alwaysloved.xyz'
    '//test.hiltondigital.uk'
